module.exports = __webpack_public_path__ + "static/media/Kawine&DineFBpost.ff636762.jpg";